<template>
    <div class="modal-roomlist">
        <div class="modal">
            <div class="modal-header">
                <div style="padding: 6px;">药品修改</div>
                <button type="button" class="btn-close" @click="closeSelf">关闭</button>
            </div>
            <div class="modal-body">
                <el-form :model="editForm" :rules="rules" ref="editForm">
                    <div>
                        <el-row>
                            <el-col :span="12" class="item">
                                <el-form-item label="药品名称" required prop="name">
                                    <el-input v-model="editForm.name"  placeholder="请输入药品名称"></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="12" class="item">
                                <el-form-item label="药品单价" required prop="price">
                                    <el-input v-model="editForm.price" type="number"  placeholder="请输入物品单价"></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="12" class="item">
                                <el-form-item label="库存" required prop="stock">
                                    <el-input v-model.number="editForm.stock"  placeholder="请输入库存"></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="12" class="item">
                                <el-form-item label="供应商" required prop="supplierDrugCode">
                                    <el-select v-model="editForm.supplierDrugCode" placeholder="请选择供应商" style="width:100%">
                                        <el-option
                                                v-for="item in SupplierDrugCodeValue"
                                                :key="item.supplierDrugCode"
                                                :label="item.name"
                                                :value="item.supplierDrugCode">
                                        </el-option>
                                    </el-select>
                                </el-form-item>
                            </el-col>
                            <el-col :span="12" class="item">
                                <el-form-item label="药品类型" required prop="waresTypeDrugCode">
                                    <el-select v-model="editForm.waresTypeDrugCode" placeholder="请选择药品类型" style="width:100%">
                                        <el-option
                                                v-for="item in WaresTypeDrugCodeValue"
                                                :key="item.waresTypeDrugCode"
                                                :label="item.name"
                                                :value="item.waresTypeDrugCode">
                                        </el-option>
                                    </el-select>
                                </el-form-item>
                            </el-col>
                            <el-col :span="12" class="item">
                                <el-form-item label="仓库" required prop="warehouseDrugCode">
                                    <el-select v-model="editForm.warehouseDrugCode" placeholder="请选择仓库" style="width:100%">
                                        <el-option
                                                v-for="item in warehouseDrugCodeValue"
                                                :key="item.warehouseDrugCode"
                                                :label="item.name"
                                                :value="item.warehouseDrugCode">
                                        </el-option>
                                    </el-select>
                                </el-form-item>
                            </el-col>
                            <el-col :span="12" class="item">
                                <el-form-item label="药品状态" required prop="status">
                                    <el-select v-model="editForm.status" placeholder="选择职工状态" style="width:100%">
                                        <el-option
                                                v-for="item in status2"
                                                :key="item.value"
                                                :label="item.label"
                                                :value="item.value">
                                        </el-option>
                                    </el-select>
                                </el-form-item>
                            </el-col>
                            
                        </el-row>
                    </div>

                </el-form>


            </div>
            <div class="modal-footer">
                <el-button :loading="loading" type="primary" @click="confirm('editForm')">修改</el-button>
            </div>
        </div>
    </div>
</template>

<script>

    import {timeStr} from "@/common/times";
    import {hex_md5} from "@/common/Base64MD5";
    import {getStaffCode} from "@/utils/auth";

    export default {
        name: 'Edit',
        props: ["SupplierDrugCodeValue","WaresTypeDrugCodeValue",'warehouseDrugCodeValue'],
        data() {
            return {
                loading: false,
                editForm:{
                    timeStr:timeStr,
                    sign:'',
                    staffCode:getStaffCode(),
                    name:'',
                    price:'',
                    waresDrugCode:'',
                    waresTypeDrugCode:'',
                    supplierDrugCode:'',
                    warehouseDrugCode:'',
                    stock:'',
                    status:''
                },
                status2: [{
                    value: 0,
                    label: '正常'
                }, {
                    value: 1,
                    label: '被禁用'
                }],
                rules:{
                    stock:[
                        { required: true, message: '请输入库存', trigger: 'blur' },
                        { type: 'number', message: '排序必须为数字值'}
                    ],
                    price:[
                        { required: true, message: '请输入物品单价', trigger: 'blur' },
                        {
                            pattern: /^(\d?)+(\.\d{0,2})?$/,
                            message: '请输入正确的金额(保留两位小数)', trigger: 'blur'
                        },
                    ],
                    warehouseDrugCode:[
                        { required: true, message: '请选择仓库', trigger: 'blur' },
                    ],
                    name:[
                        { required: true, message: '请输入药品名称', trigger: 'blur' },
                    ],
                    waresTypeDrugCode:[
                        { required: true, message: '请选择药品类型', trigger: 'blur' },
                    ],
                    supplierDrugCode:[
                        { required: true, message: '请选择供应商', trigger: 'blur' },
                    ],
                }

            }
        },

        methods: {

            init(row){
                this.editForm.name = row.name;
                this.editForm.waresTypeDrugCode = row.waresTypeDrugCode;
                this.editForm.warehouseDrugCode = row.warehouseDrugCode;
                this.editForm.waresDrugCode = row.waresDrugCode;
                this.editForm.price = row.price;
                this.editForm.supplierDrugCode = row.supplierDrugCode;
                this.editForm.stock = row.stock;
                this.editForm.status = row.status;
            },
            closeSelf() {
                this.$emit("closeEdit");
            },

            confirm(editForm){
                this.$refs[editForm].validate((valid) => {
                    if(valid){
                        this.addSubmit();
                    }else {
                        console.log('error submit!!');
                        return false;
                    }
                })


            },

            addSubmit(){

                if(this.loading){
                    return;
                }else{
                    this.loading = true;
                }

                this.editForm.sign = hex_md5("timeStr=" + timeStr + "&key="+this.$signKey);

                this.$axios({
                    method: 'post',
                    url: this.$institutionUrl+"WaresDrug/Edit",
                    data: this.editForm
                }).then(
                    (response) => {
                        this.loading = false;
                        if (response.data.error == 0) {
                            this.$emit("closeEdit");
                            this.$emit("getList");
                        }else if(response.data.error == 1){
                            this.$message({type: 'info', message: response.data.message});
                        }
                    }
                )
            },

        }
    }


</script>





<style lang="scss" scoped>

    .modal-roomlist {
        position: fixed;
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;
        background-color: rgba(0,0,0,.3);
        display: flex;
        justify-content: center;
        align-items: center;
        z-index: 99;
        
        .modal {
            
            background-color: #fff;
            box-shadow:   0 2px 4px rgba(0, 0, 0, .12), 0 0 6px rgba(0, 0, 0, .04);
            overflow-x:auto;
            display: flex;
            flex-direction: column;
            border-radius: 10px;
            width: 600px;

            

            .modal-header {
                border-bottom: 1px solid #eee;
                color: #313131;
                justify-content: space-between;
                padding: 10px;
                display: flex;
            }
            .modal-body {
                position: relative;
                padding: 20px 0px;
                z-index: 99;
                height: 100%;
            }
            .modal-footer {
                border-top: 1px solid #eee;
                justify-content: flex-end;
                padding: 15px;
                display: flex;
            }


        }

    }


    .btn-close, .btn-confirm {
        border-radius: 8px;
        margin-left:16px;
        width:56px;
        height: 36px;
        border:none;
        cursor: pointer;
    }
    .btn-close {
        color: #313131;
        background-color:transparent;
    }



    .row{
        padding: 10px 0px;
    }
    .item{
        padding: 0px 20px;
    }
    .label{
        padding: 5px 0px;
    }


</style>
